"use client";
import TransitionLink from "../transitionLink";
import { Marquee } from "@/app/components/marquee";
import Image from "next/image";
import { useAppContext } from "../appContext";
import { usePathname } from "next/navigation";

export function MarqueeContent({ subItem }: any) {
  return (
    <>
      <span className="h1 uppercase text-center pb-[1vw] lg:pb-3">
        {subItem.title}
      </span>
      {subItem.icon?.asset?.url ? (
        <Image
          src={subItem.icon.asset.url}
          alt={subItem.icon.alt ?? `${subItem.title} icon`}
          aria-hidden={subItem.icon.alt ? undefined : true}
          className="w-[7vw] h-[7vw] lg:w-20 lg:h-20"
          width={96}
          height={96}
        />
      ) : (
        <span className="pb-[1vw] lg:pb-3">—</span>
      )}
    </>
  );
}

export function ServiceMenuItem({ subItem, isHeader }: any) {
  const { toggleMenu } = useAppContext();
  const pathname = usePathname();

  const currentPage = pathname.includes(subItem.page?.slug?.current);
  return (
    <TransitionLink
      href={`/${subItem.page?.slug?.current}`}
      onPointerUp={() => toggleMenu(null)}
      classes={`${isHeader && currentPage ? "bg-black text-white" : isHeader && !currentPage ? "bg-white" : ""} relative h1 uppercase text-center w-full flex flex-col justify-center border-b border-black group overflow-hidden h-[10vw] lg:h-28`}
    >
      <span className="pb-[1vw] lg:pb-3 w-full h-full top-0 gap-8 flex justify-center items-center whitespace-nowrap">
        {subItem.title}
      </span>

      <div className="w-full overflow-hidden bg-primary h-0 group-hover:h-full bottom-0 group-hover:top-[0] group-hover:bottom-[auto] gap-8 absolute transition-all duration-200 group-hover:delay-100 flex justify-center items-end group-hover:items-start">
        <Marquee
          direction="left"
          className="w-full h-[10vw] lg:h-28 flex items-center whitespace-nowrap gap-8"
          innerClassName="flex items-center gap-8 text-black"
        >
          <MarqueeContent subItem={subItem} />
          <MarqueeContent subItem={subItem} />
          <MarqueeContent subItem={subItem} />
        </Marquee>
      </div>
    </TransitionLink>
  );
}
